var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 128,
    viewBox: "0 0 103 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_317_722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04492 118.136L4.04492 28.0645L30.1404 0L96.7771 0C97.8066 0 98.6411 0.834525 98.6411 1.86396V118.136C98.6411 119.165 97.8066 120 96.7771 120H5.90889C4.87945 120 4.04492 119.165 4.04492 118.136Z",
    fill: "#8BCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0491 90.1842C35.2346 90.1842 36.1069 89.2448 36.1069 88.037C36.1069 86.8067 35.2346 85.8897 34.0491 85.8897C32.886 85.8897 32.0137 86.8067 32.0137 88.037C32.0137 89.2448 32.886 90.1842 34.0491 90.1842ZM40.9305 89.8711H44.7329L48.9157 77.3453H45.7619L43.9277 83.5858C43.5922 84.816 43.2567 86.1133 42.9212 87.3883H42.8093C42.4738 86.1133 42.1383 84.816 41.8028 83.5858L39.9687 77.3453H36.6583L40.9305 89.8711ZM56.2826 90.1842C57.826 90.1842 59.4141 89.6474 60.6443 88.7975L59.5259 86.7844C58.6312 87.3436 57.7365 87.6567 56.7076 87.6567C54.8511 87.6567 53.5091 86.5831 53.2407 84.5252H60.9575C61.0469 84.2345 61.114 83.6305 61.114 83.0043C61.114 79.5596 59.3246 77.0321 55.88 77.0321C52.9051 77.0321 50.0421 79.5596 50.0421 83.6082C50.0421 87.7462 52.7709 90.1842 56.2826 90.1842ZM53.1959 82.3332C53.442 80.5215 54.6051 79.582 55.9248 79.582C57.5352 79.582 58.2957 80.6557 58.2957 82.3332H53.1959ZM63.8217 89.8711H67.1098V82.4003C67.8032 80.5886 68.9886 79.9399 69.9728 79.9399C70.4873 79.9399 70.8452 80.007 71.2925 80.1412L71.8517 77.3005C71.4714 77.1439 71.0688 77.0321 70.3754 77.0321C69.0781 77.0321 67.7361 77.9268 66.819 79.5596H66.7519L66.5058 77.3453H63.8217V89.8711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1404 0L4.04492 28.0645H28.2765C29.3059 28.0645 30.1404 27.23 30.1404 26.2006V0Z",
    fill: "#E1F3FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_317_722",
    x: 0.0449219,
    y: 0,
    width: 102.596,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_317_722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_317_722",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3c0a67e09324548048379e124e36dbed.svg";
export { ForwardRef as ReactComponent };